import React, { useState, useRef, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import FormInputField from 'src/components/common/formInputField';
import { useCategoryActions } from 'src/store/category/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { CategoryModel } from 'src/models/categoryModel';
import Loader from 'src/components/loader';
interface IProps {
  contentTypeAddFlag: string;
}
const AddNewContentType: React.FC<IProps> = ({ contentTypeAddFlag }) => {
  const dispatch = useDispatch();
  const categoryActions = useCategoryActions(dispatch);
  const ref = useRef<HTMLButtonElement>(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue
  } = useForm();
  const { singleContentType, isContentTypeSaved, isContentTypeUpdated, isContentTypeSavedLoading } =
    useSelector((state: RootState) => {
      return {
        singleContentType: state.category.singleContentType,
        isContentTypeSaved: state.category.isContentTypeSaved,
        isContentTypeUpdated: state.category.isContentTypeUpdated,
        isContentTypeSavedLoading: state.category.isContentTypeSavedLoading
      };
    });
  const onSubmit = (data: any) => {
    if (contentTypeAddFlag === 'Add') {
      categoryActions.addContentTypeRequest(data);
    } else {
      const payloadData = {
        contentTypeId: data.id,
        updateData: [
          { op: 'replace', path: 'contentType', value: data.contentType },
          { op: 'replace', path: 'description', value: data.description }
        ]
      };
      categoryActions.updateContentTypeRequest(payloadData);
    }
  };

  useEffect(() => {
    if (isContentTypeSaved || isContentTypeUpdated) {
      if (ref.current) {
        ref.current.click();
        handleCloseClick();
      }
    }
  }, [isContentTypeSaved, isContentTypeUpdated]);

  useEffect(() => {
    if (singleContentType) {
      reset(singleContentType);
    }
  }, [singleContentType]);
  const handleCloseClick = () => {
    reset({
      contentType: '',
      description: ''
    });
  };
  return (
    <div>
      <div
        className="modal fade"
        id="AddNewContentType"
        aria-labelledby="AddNewTagLabel"
        aria-hidden="true">
        <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
          <div className="modal-content">
            <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
              <h5
                className="text-xl font-semibold leading-normal text-center w-full"
                id="AddNewTagLabel">
                {contentTypeAddFlag === 'Add' ? 'Add' : 'Update'} New Content Type
              </h5>
              {isContentTypeSavedLoading && <Loader />}
              <button
                onClick={() => handleCloseClick()}
                ref={ref}
                type="button"
                className="dismiss-btn"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body relative py-4 px-10">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`form-group mb-3`}>
                  <FormInputField
                    label={'Name'}
                    type={'text'}
                    fieldName={'contentType'}
                    register={register}
                    errors={errors}
                    isRequired={true}
                  />
                </div>

                <div className={`form-group mb-3`}>
                  <FormInputField
                    label={'Description'}
                    type={'text'}
                    fieldName={'description'}
                    register={register}
                    errors={errors}
                    isRequired={false}
                  />
                </div>

                <div className="modal-footer mt-5 flex flex-shrink-0 flex-wrap items-center justify-center px-4 pb-2 rounded-b-md">
                  <button
                    type="submit"
                    className="px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-0">
                    Save Changes
                  </button>
                  <button
                    onClick={() => handleCloseClick()}
                    type="button"
                    className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                    data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewContentType;
